import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ExpenseServices = {

    getAllExpense: async () => {
        try {
            const response = await axios.get(ENDPOINT.Expense);
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },
   
    getAllExpenseByBillid: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINT.lastAddedBill}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },


      getRecentExpenses: async () => {
        try {
            const response = await axios.get(`${ENDPOINT.Expense}/recent`);
            return response.data;
        } catch (error) {
            console.error("Error fetching recent expenses:", error.message);
            throw error;
        }
    },

    createExpense: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.Expense, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },

    updateExpense: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.Expense}/${id}`, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },

    deleteExpense: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.Expense}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },

    // payment 
    getAllPayment: async () => {
        try {
            const response = await axios.get(ENDPOINT.Payment);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    createPayment: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.Payment, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    getPaymentByQuId: async ( id) => {
        try {
            const response = await axios.get(`${ENDPOINT.Payment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    updatePayment: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.Payment}`, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    deletePayment: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.Payment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    // utility bills

     getAllUBtype: async () => {
        try {
            const response = await axios.get(ENDPOINT.UBType);
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },


      getUBtypeById: async () => {
        try {
            const response = await axios.get(`${ENDPOINT.UBType}/recent`);
            return response.data;
        } catch (error) {
            console.error("Error fetching recent expenses:", error.message);
            throw error;
        }
    },

    createUBtype: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.UBType, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },

    updateUBtype: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.UBType}/${id}`, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },

    deleteUBtype: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.UBType}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Expense:", error.message);
            throw error;
        }
    },

    // bill installment payment

    getAllBillPayment: async () => {
        try {
            const response = await axios.get(ENDPOINT.BillPayment);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    createBillPayment: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.BillPayment, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    getPaymentByBillId: async ( id) => {
        try {
            const response = await axios.get(`${ENDPOINT.BillPayment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    updateBillPayment: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.BillPayment}`, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    deleteBillPayment: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.BillPayment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    // project expense

    getAllProjectPayment: async () => {
        try {
            const response = await axios.get(ENDPOINT.ProjectPayment);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    createProjectPayment: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.ProjectPayment, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    getPaymentByProjectId: async ( id) => {
        try {
            const response = await axios.get(`${ENDPOINT.ProjectPayment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    updateProjectPayment: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.ProjectPayment}`, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    deleteProjectPayment: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.ProjectPayment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },
    
    // po expense

    getAllPoPayment: async () => {
        try {
            const response = await axios.get(ENDPOINT.ProjectPayment);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    createPoPayment: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.PoPayment, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    getPaymentByPoId: async ( id) => {
        try {
            const response = await axios.get(`${ENDPOINT.PoPayment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    updatePoPayment: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.PoPayment}`, data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },

    deletePoPayment: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.PoPayment}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Payment:", error.message);
            throw error;
        }
    },


};
